import { useMutation } from "@tanstack/react-query";
import { updateProductConfigsByStudioId } from "../api/updateProductConfigsByStudioId";
import { ProductsConfigs } from "../types";

type UpdateAllProductsParams = {
  studioId: string;
  productConfigs: ProductsConfigs;
};

export const useProductConfigsByStudioIdMutation = () => {
  return useMutation({
    mutationFn: async ({
      studioId,
      productConfigs,
    }: UpdateAllProductsParams) => {
      const updatePromises = Object.entries(productConfigs).map(
        async ([productId, config]) => {
          return updateProductConfigsByStudioId({
            studioId,
            productId,
            productConfigs: config,
          });
        },
      );
      return await Promise.all(updatePromises);
    },
  });
};
